import { isArray } from "../../utils";
import { snowplowStructGenerator } from "./utils";

export const snowplowEventGenerator = ({
	schema = "",
	data = {},
	entities = [],
} = {}) => {
	if (
		typeof schema !== "string" ||
		typeof data !== "object" ||
		!isArray(entities)
	)
		return null;
	return {
		event: snowplowStructGenerator({ schema, data }),
		context: entities,
	};
};
